<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'HomeView',
  data() {
    return {
      loading: true,
      obj: {},
      ipAddress: ""
    }
  },
  // mounted() {
  //
  //   let str = location.href.split("str=")[1]
  //   this.$router.push({
  //     path: "/",
  //     query: { str: str }
  //   })
  //
  // },
  methods: {

  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
</style>
